module.exports = __webpack_public_path__ + "static/media/fondo-land.34bdf715.png";